import BorderedSection from './BorderedSection'

const EmptyColumn = props => (
  <BorderedSection
    flex={1}
    sx={{ borderTopWidth: 0, borderBottomWidth: 0, boxSizing: 'border-box' }}
    {...props}
  />
)

export default EmptyColumn
